export interface SoilAssessment {

    vess?: number

    wormCount?: number
    wormType?: number

    macroFauna?: number

    infiltrationRate?: number

    pH_0_5?: number
    pH_5_20?: number
    pH_20?: number

}

export const vessOptions: [number, string][] = [
    [1, "1"],
    [2, "2"],
    [3, "3"],
    [4, "4"],
    [5, "5"],
]

export const wormTypeOptions: [number, string][] = [
    [1, "Shallow"],
    [2, "Deep"],
    [3, "Both"],
]

export const infiltrationRateOptions: [number, string][] = [
    [1, "Slow"],
    [2, "Moderate"],
    [3, "Rapid"],
]
